export default __webpack_public_path__ + "static/media/permanent_life_dark.bfd28127.png";